/*
 * $Id:: ConfirmLogoutDialog.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../providers';

const useStyles = makeStyles((_theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    unsaved: {
        fontWeight: '600',
    },
    backButton: {
        '&:focus-visible': {
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        background: _theme.palette.text.mainGreen,
        borderColor: _theme.palette.text.mainGreen,
        textTransform: 'uppercase',
        '&:hover': {
            background: _theme.palette.text.mainGreen,
            borderColor: _theme.palette.text.mainGreen,
        },
    },
    accept: {
        color: _theme.palette.text.mainGreen,
        borderColor: _theme.palette.text.mainGreen,
        textTransform: 'uppercase',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
}));
const ConfirmLogoutDialog = ({ open, onAccept, onCancel }) => {
    const classes = useStyles();
    const unsavedChanges = <span className={classes.unsaved}>{t('logout.unsaved.changes.lost')}</span>;
    return (
        <Dialog open={open} aria-labelledby="reset-account-accept-dialog" className={classes.dialogOverride} onBackdropClick={onCancel}>
            <DialogTitle id="form-dialog-title">{t('logout.confirmation.title')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('logout.confirmation.description', { unsavedChanges })}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button disableFocusRipple id="logout-btn-confirm" variant="outlined" onClick={onAccept} className={classes.accept}>
                    {t('log.out')}
                </Button>
                <Button disableFocusRipple id="back-btn-confirm" variant="contained" onClick={onCancel} className={classes.backButton}>
                    {t('back')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmLogoutDialog;
